import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../../config/constants";
// Components
import UseFetch from "../../../../../config/useFetch";
import { DeleteDiv, DeleteText, BackAndDeleteDiv, BackButton, DeleteButton } from "./styles";

const DeleteEvaluation = ({
  setIsShowDeleteEvaluationPopup,
  setIsShowingEvaluationPopup,
  patientId,
  evaluationUnit,
  recharge,
  setRecharge,
}) => {
  const [t] = useTranslation("global");

  const deleteEvaluation = () => {
    UseFetch("put", `${WEB_SERVICE_MIMS}/icu/delete-evaluation/${patientId}`, new AbortController(), { evaluationUnit })
      .then(({ data }) => {
        if (data.evaluationDeleted) {
          toast.success(t("evaluationDeletedMessage"));
          setIsShowDeleteEvaluationPopup(false);
          setIsShowingEvaluationPopup(false);
          setRecharge(!recharge);
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Delete evaluation: ", error);
      });
  };

  return (
    <DeleteDiv>
      <DeleteText>{t("evaluationDeleteMessage")}</DeleteText>
      <BackAndDeleteDiv>
        <BackButton onClick={() => setIsShowDeleteEvaluationPopup(false)}>{t("cancel")}</BackButton>
        <DeleteButton onClick={deleteEvaluation}>{t("delete")}</DeleteButton>
      </BackAndDeleteDiv>
    </DeleteDiv>
  );
};

export default DeleteEvaluation;
